import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	container: {
		height: '100%',
	},
});
